<!-- eslint-disable max-lines -->
<!-- eslint-disable max-lines-per-function -->
<template>
    <div class="assetHandover-detail-Wrap">
        <div class="formBox" v-loading="isLoading">
            <span>选择交接人：</span>
            <!--
                选择交接人：权限范围内，个人用户可选择自己，
                管理层可选择自己权限范围内：本部门个人用户，上级经理为本人的用户（个人和管理层），下级部门的所有人。
            -->
            <el-select
                v-model="handoverPersonId"
                :disabled="operationType === 'view' || !!transferNoId"
                filterable
                @change="handleChangeHandoverPerson"
                placeholder="请输入交接人">
                <el-option
                    v-for="item in handoverPersonOptions"
                    :key="item.userCode"
                    :label="item.userName"
                    :value="item.userCode">
                </el-option>
            </el-select>

            <small>(管理层可选择下属，普通员工仅可选择本人)</small>

            <lotsButton
                v-if="operationType === 'add' || operationType === 'edit'"
                type="primary"
                icon="el-icon-notebook-2"
                size="mini"
                title="加载用户资产"
                :disabled="!handoverPersonId || isTimer"
                @click="loadUserAssets"
            >
                加载用户资产
            </lotsButton>

            <lotsButton
                v-if="isInitCustomerAssets && (operationType === 'add' || operationType === 'edit')"
                type="primary"
                icon="el-icon-s-flag"
                size="mini"
                title="保存草稿"
                :disabled="!handoverPersonId || isTimer"
                @click="saveDraft('save')"
                class="saveBtn"
            >
                保存草稿
            </lotsButton>

            <lotsButton
                v-if="isInitCustomerAssets && (operationType === 'add' || operationType === 'edit')"
                type="primary"
                icon="el-icon-finished"
                size="mini"
                title="提交"
                :disabled="!transferNoId || isTimer"
                @click="submitVerity"
                class="submitBtn"
            >
                提交
            </lotsButton>
        </div>

        <!-- 点击加载用户资产后，才渲染用户的所有的资产。 -->
        <div class="contentBox" v-if="isInitCustomerAssets">
            <p class="title">资产转移-线索</p>
            <clue ref="clue" />

            <p class="title">资产转移-客户交换</p>
            <customer ref="customer" :industryData="industryData" @updateAssigneeList="updateAssigneeList" />

            <p class="title">资产转移-客户系交换</p>
            <customerGroup ref="customerGroup" :industryData="industryData" />

            <p class="title">资产转移-全量仓库</p>
            <warehouse ref="warehouse" :industryData="industryData" />

            <p class="title">资产转移-全量商机</p>
            <fullBusiness ref="fullBusiness" :industryData="industryData" />

            <p class="title">资产转移-投标商机</p>
            <biddingOppo ref="biddingOppo" :industryData="industryData" />

            <p class="title">资产转移-联系人</p>
            <contact ref="contact" />

            <!-- <p class="title">资产转移-合同</p> -->
            <!-- <contract ref="contract" /> -->

            <p class="title">资产转移-提成分配明细</p>
            <allocationDetails ref="allocationDetails" />

            <template v-if="operationType === 'view' && mipUrl">
                <p class="title">流程信息</p>

                <div class="header-operation">
                    <lots-button
                        size="mini"
                        type="primary"
                        v-if="!['7'].includes(flowStatus) && isHasApprovalAuthority"
                        @click="submitMip"
                    >
                        mip提交
                    </lots-button>
                </div>

                <iframe class="ifr" :src="mipUrl" />
            </template>
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted, getCurrentInstance, provide } from '@vue/composition-api';
import store from '@/store';
import { Message } from 'element-ui';
import lotsButton from '@/components/lots/lotsButton';
import clue from '@/modules/mdm/views/customerModules/assetHandover/clue/index.vue';
import customer from '@/modules/mdm/views/customerModules/assetHandover/customer/index.vue';
import customerGroup from '@/modules/mdm/views/customerModules/assetHandover/customerGroup/index.vue';
import warehouse from '@/modules/mdm/views/customerModules/assetHandover/warehouse/index.vue';
import fullBusiness from '@/modules/mdm/views/customerModules/assetHandover/fullBusiness/index.vue';
import biddingOppo from '@/modules/mdm/views/customerModules/assetHandover/biddingOppo/index.vue';
import contact from '@/modules/mdm/views/customerModules/assetHandover/contact/index.vue';
// import contract from '@/modules/mdm/views/customerModules/assetHandover/contract/index.vue';
import allocationDetails from '@/modules/mdm/views/customerModules/assetHandover/allocationDetails/index.vue';
import { getDetailByCode, saveDraftOpera, submitApproval, checkVerityApi } from '@/modules/mdm/api/customer/assetHandover/index.js';
import { getIndustryTree } from '@mdm/api/contractManage/contractRegistration.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { getAdminRole } from '@mdm/api/leadManage/leadImport.js';
import configurl from '@/config/user.env';
import { checkApprovalAuthority } from '@/modules/mdm/utils/flowUtils.js';

export default {
    name: 'assetHandover-setting',
    components: {
        lotsButton,
        clue,
        customer,
        customerGroup,
        warehouse,
        fullBusiness,
        biddingOppo,
        contact,
        // contract,
        allocationDetails
    },
    props: {
        handoverPersonOptions: {
            type: Array,
            default() {
                return [];
            }
        },
        dictDatas: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 加载中
        const isLoading = ref(false);
        // 交接单编号
        const transferNo = ref('');
        // 交接单编号ID
        const transferNoId = ref('');
        // 操作类型，默认是null。
        const operationType = ref(null);
        // 字典数据
        const dictDatas = ref({});
        // 获取Vue实例
        const instance = getCurrentInstance();
        // 当前路由信息
        const route = instance ? instance.$route : null;
        // 选择交接人
        const handoverPersonId = ref('');
        // 流程状态
        const flowStatus = ref('');
        // 流程信息
        const workflowInfo = ref({});
        // mip地址
        const mipUrl = ref('');
        // 是否有审批权限
        const isHasApprovalAuthority = ref(false);
        // 当前用户信息
        const { userName, userCode } = store.getters.user;

        onMounted(async () => {
            // 获取是否是管理员角色
            getAdminRoleData();
            // 获取行业树列表
            getIndustryTreeList();
            // 初始化字典数据
            await initDictData();
            // 检查URL参数
            if (route && route.query.mode) {
                const mode = route.query.mode;
                operationType.value = mode;
            }
            if (route && route.query.transferNo) {
                transferNo.value = route.query.transferNo;
                getDetailByCode({
                    transferNo: transferNo.value
                }).then(res => {
                    if (+res.code === 0) {
                        transferNoId.value = res.data.id; // 交接单编号ID
                        handoverPersonId.value = res.data.transferUserCode; // 交接人ID
                        loadUserAssets();
                        handleChangeHandoverPerson(res.data.transferUserCode);
                        if (res.data.workflowInfo) {
                            flowStatus.value = res.data.status; // 流程状态
                            workflowInfo.value = res.data.workflowInfo; // 流程信息
                            // 流程信息iframe地址
                            mipUrl.value = null;
                            if (res.data?.workflowInfo?.mipId) {
                                setTimeout(() => {
                                    mipUrl.value = `${configurl.iflowUrl}?fdId=${res.data?.workflowInfo?.mipId}&fdTemplateKey=CRM_asset_transfer_flow&userCode=${userCode}&userName=${userName}`;
                                }, 100);
                                const fdId = res.data?.workflowInfo?.mipId;
                                checkApprovalAuthority(fdId, userCode).then(isAuth => {
                                    if (isAuth) {
                                        isHasApprovalAuthority.value = true;
                                    }
                                });
                            }
                        }
                    }
                });
            }
            window.addEventListener('message', messageFunc, false);
            createMetaNode();
        });

        // 9大模块的字典数据，统一入口
        // 导出字典选项
        const exportOptions = reactive({});
        const initDictData = () => {
            const dictKeys = [
                'SYS_SUPPLIER_INDUSTRY', // 行业大类
                'NEOCRM_RESP_DIVIDE', // 分摊类型
                'MANAGER_BILL_SOURCE_REMARK', // 单据来源类型
                'MANAGER_ARCHIVE_MAINTAIN_STATUS', // 维护状态
                'MONITOR_STATUS', // 异常数据
                'NEOCRM_OPPORTUNITY_STATUS', // 商机状态
                'NEOCRM_WH_TYPE', // 仓库类型
                'NEOCRM_BUSINESS_TYPE', // 商机大类
                'LCRM_FOLLOW_UP_STATUS', // 跟进状态
                'SYS_WM_CONTRACT_CHARACTER', // 合同性质
                'SYS_BMS_BUSI_TYPE', // 业务类型
                'SYS_LMDM_BUS_TYPE', // 业务大类
                'SYS_CUST_RELATION_TYPE', // 客户系
                'NEOCRM_CUSTOMER_LEVEL', // 客户等级
                'SYS_RELATION_LEVEL', // 客户控制类型
                'LMDM_CUSTOMER_CHANNEL', // 内外渠
                'SRM_SUPPLIER_INDUSTRY', // 行业大类
                'SYS_INDUSTRY_TYPE', // 行业类型
                'NEOCRM_BUSINESS_CATEGORY', // 业务类型
                'LCRM_ASSET_INFO_EXPORT' // 获取资产导出字典选项内容
            ];
            getDictDataApi({
                dictCodes: dictKeys.join(',')
            }).then(res => {
                dictDatas.value = res.data || {};
                // 获取资产导出字典选项内容
                Object.assign(exportOptions, res.data.LCRM_ASSET_INFO_EXPORT || {});
            });
        };

        // 是否是管理员角色
        const isAdminRole = ref(false);
        const getAdminRoleData = () => {
            getAdminRole({ mipCode: userCode }).then(res => {
                if (res && +res.code === 0) {
                    isAdminRole.value = res.data;
                }
            });
        };

        // 交接人改变时，加载用户资产
        const currentHandoverPerson = ref({});
        const handleChangeHandoverPerson = (userCode) => {
            currentHandoverPerson.value = props.handoverPersonOptions.find(item => item.userCode === userCode) || {};
        };

        // 检查并获取交接单号
        const checkTransferNo = async () => {
            // 如果交接单号已存在，直接返回成功
            if (transferNo.value) {
                return Promise.resolve();
            }
            try {
                // 调用保存草稿接口获取交接单号
                const res = await saveDraft();
                if (+res.code === 0) {
                    transferNo.value = res.data.transferNo;
                    return Promise.resolve();
                }
                // 接口调用失败，返回错误信息
                return Promise.reject(new Error(res.msg || '获取交接单号失败'));
            } catch (error) {
                Message.error(error.msg || '获取交接单号失败');
                return Promise.reject(error);
            }
        };

        // 保存草稿
        const saveDraft = (type) => {
            return new Promise((resolve, reject) => {
                const params = {
                    transferUserCode: currentHandoverPerson.value.userCode, // 交接人MIP
                    transferUserName: currentHandoverPerson.value.userName, // 交接人姓名
                    transferDeptCode: currentHandoverPerson.value.orgCode, // 交接人部门编码
                    transferDeptName: currentHandoverPerson.value.orgName, // 交接人部门名称
                    id: transferNoId.value ? transferNoId.value : null
                };
                saveDraftOpera(params).then(res => {
                    if (+res.code === 0) {
                        // 更新父组件的交接单号信息
                        transferNo.value = res.data.transferNo;
                        transferNoId.value = res.data.id;
                        const timer = 1200;
                        setTimeout(() => {
                            setupContext.emit('createSuccessHandle');
                        }, timer);
                        if (type === 'save') {
                            // setupContext.emit('close');
                            Message.success('保存草稿成功');
                        } else {
                            resolve(res);
                        }
                    }
                }).catch(err => {
                    reject(new Error(err.msg || '系统服务出错，请稍后再试'));
                });
            });
        };

        // 提交验证
        const submitVerity = () => {
            submitApproval({
                transferNo: transferNo.value
            }).then(res => {
                if (+res.code === 0) {
                    Message.success('提交成功');
                    setupContext.emit('close');
                }
            }).catch(err => {
                Message.error(err.message);
            });
        };

        // 行业树列表
        const industryData = ref([]);
        // 获取行业树列表
        const getIndustryTreeList = () => {
            return getIndustryTree({
                industryStatus: 1 // 0-停用、1-启用
            }).then(res => {
                if (res && +res.code === 0) {
                    industryData.value = res.data;
                }
            });
        };

        // 定时器，用于控制加载用户资产按钮的禁用状态。
        const isTimer = ref(false);
        // 初始化客户资产
        const isInitCustomerAssets = ref(false);
        // 加载用户资产
        const loadUserAssets = () => {
            // 禁用加载用户资产按钮，防止重复点击。
            isTimer.value = true;
            // 3000毫秒后，启用加载用户资产按钮。
            const timerIsTimer = 3000;
            setTimeout(() => {
                isTimer.value = false;
            }, timerIsTimer);
            // 设置为已加载状态，显示内容
            isInitCustomerAssets.value = false;
            const timerIsInit = 100;
            // 添加延时目的，是为了直接重置各个组件的初始状态。
            setTimeout(() => {
                isInitCustomerAssets.value = true;
            }, timerIsInit);

            // 定义需要加载的组件列表和顺序
            const componentsToLoad = [
                'clue',
                'customer',
                'customerGroup',
                'warehouse',
                'fullBusiness',
                'biddingOppo',
                'contact',
                // 'contract',
                'allocationDetails'
            ];

            // 延迟时间（毫秒）
            const delayTime = 300;

            // 使用Promise链依次加载组件
            let promise = Promise.resolve();

            componentsToLoad.forEach((componentName, index) => {
                promise = promise.then(() => {
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            const component = setupContext.refs[componentName];
                            if (component && component.loadData) {
                                // 加载组件数据，传递交接人mip和交接单编号
                                component.loadData(handoverPersonId.value, transferNo.value);
                            }
                            resolve();
                        }, delayTime);
                    });
                });
            });
        };

        // 这里是用户勾选了自动转移客户关联资产，保存承接人后，刷新用户其他资产相关的数据列表
        const updateAssigneeList = () => {
            const refreshComponentsList = [
                'warehouse',
                'fullBusiness',
                'biddingOppo',
                'contact',
                // 'contract',
                'allocationDetails'
            ];
            refreshList(refreshComponentsList);
        };

        // 刷新列表方法
        const defaultComponentsList = [
            'clue',
            'customer',
            'customerGroup',
            'warehouse',
            'fullBusiness',
            'biddingOppo',
            'contact',
            // 'contract',
            'allocationDetails'
        ];
        const refreshList = (list = defaultComponentsList) => {
            setupContext.root.$nextTick(() => {
                // 需要刷新的组件列表和顺序
                const componentsToLoad = list;

                // 延迟时间（毫秒）
                const delayTime = 200;

                // 使用Promise链依次刷新组件
                let promise = Promise.resolve();

                componentsToLoad.forEach((componentName, index) => {
                    promise = promise.then(() => {
                        return new Promise((resolve) => {
                            // eslint-disable-next-line max-nested-callbacks
                            setTimeout(() => {
                                const component = setupContext.refs[componentName];
                                if (component && component.tableList && component.tableList.getList) {
                                    component.tableList.getList();
                                }
                                resolve();
                            }, delayTime);
                        });
                    });
                });
            });
        };

        // eslint-disable-next-line complexity
        // 流程信息iframe地址
        const currentTime = ref('');
        const submitMip = () => {
            checkVerityApi({
                transferNo: transferNo.value
            }).then(res => {
                if (+res.code === 0) {
                    const content = window;
                    content.frames && content.frames.length && content.frames[0]
                        && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
                    content.frames && content.frames.length && content.frames[1]
                        && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
                    currentTime.value = new Date().getTime();
                    store.commit('updateIflowPage', { pageTime: currentTime.value });
                    setTimeout(() => {
                        getDetailByCode({
                            transferNo: transferNo.value
                        }).then(res => {
                            if (+res.code === 0) {
                                if (res.data.workflowInfo) {
                                    flowStatus.value = res.data.status; // 流程状态
                                    workflowInfo.value = res.data.workflowInfo; // 流程信息
                                    // 流程信息iframe地址
                                    mipUrl.value = null;
                                    if (res.data?.workflowInfo?.mipId) {
                                        const timer = 1500;
                                        // eslint-disable-next-line max-nested-callbacks
                                        setTimeout(() => {
                                            mipUrl.value = `
                                                ${configurl.iflowUrl}?fdId=${res.data?.workflowInfo?.mipId}&fdTemplateKey=CRM_asset_transfer_flow&userCode=${userCode}&userName=${userName}`;
                                        }, timer);
                                    }
                                }
                            }
                        });
                    }, 100);
                }
            });
        };

        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const mipId = workflowInfo.value.mipId;
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/mod/mdm/assetHandover?mode=view&transferNo=${transferNo.value}&fdId=${mipId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };

        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const timer = 1200;
                    setTimeout(async () => {
                        setupContext.emit('createSuccessHandle');
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
            });
        };

        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            const params = prepareApproveParams(event.data);
            handleApproveProcess(params);
        };

        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };

        // 提供响应式数据
        provide('operaType', operationType);
        provide('adminRole', isAdminRole);
        provide('exportOpt', exportOptions);
        provide('dictDatasOpt', dictDatas);
        provide('transferNo', transferNo);
        provide('transferNoId', transferNoId);
        provide('checkTransferNo', checkTransferNo);

        return {
            isLoading,
            loadUserAssets,
            handoverPersonId,
            isInitCustomerAssets,
            refreshList,
            saveDraft,
            submitVerity,
            isTimer,
            operationType,
            handleChangeHandoverPerson,
            industryData,
            updateAssigneeList,
            mipUrl,
            submitMip,
            transferNoId,
            workflowInfo,
            flowStatus,
            isHasApprovalAuthority
        };
    }
};
</script>

<style lang="less" scoped>
.assetHandover-detail-Wrap {
    display: flex;
    flex-direction: column;

    .formBox {
        display: flex;
        align-items: center;
        padding-top: 10px;
        margin-bottom: 10px;
        small {
            display: inline-block;
            color: #909399;
            margin: 0 8px;
        }

        .saveBtn {
            position: absolute;
            right: 103px;
            z-index: 1;
        }

        .submitBtn {
            position: absolute;
            right: 32px;
            z-index: 1;
        }
    }

    .contentBox {
        height: calc(100vh - 192px);
        overflow: auto;
        padding-right: 20px;

        .title {
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 15px;
        }

        .ifr {
            width: 100%;
            height: 100vh;
            border: none;
        }
    }
}

</style>
